@if (src) {
  <ng-template #content>
    <img [src]="src" alt="Map capture at the pin" loading="lazy" />
    <!-- One hint only (Sri 2026-09-28): the pin moved since the capture. The image already shows any markup. -->
    @if (showBadges && mapMoved) {
      <div class="design-capture-preview-badges">
        <span class="design-capture-preview-badge design-capture-preview-moved" data-testid="design-capture-preview-moved">Map moved</span>
      </div>
    }
  </ng-template>
  @if (viewOnClick && !actionLabel) {
    <button type="button" class="design-capture-preview design-capture-preview-action" data-testid="design-capture-preview"
      [style.height]="height" aria-label="View map markup" (click)="view($event)">
      <ng-container [ngTemplateOutlet]="content" />
    </button>
  } @else if (actionLabel) {
    <button type="button" class="design-capture-preview design-capture-preview-action" data-testid="design-capture-preview"
      [style.height]="height" [attr.aria-label]="actionLabel" [disabled]="disabled" (click)="activate.emit()">
      <ng-container [ngTemplateOutlet]="content" />
    </button>
  } @else {
    <div class="design-capture-preview" data-testid="design-capture-preview" [style.height]="height">
      <ng-container [ngTemplateOutlet]="content" />
    </div>
  }
}
